import { EDocumentsStatus } from '@/app/[locale]/(dashboard)/dashboard/documents/domain/enums/documents.enum';
import { cn } from '@/lib/utils';

export type TStatusTone = 'danger' | 'info' | 'neutral' | 'success' | 'warning';
export type TStatusBadgeVariant = 'destructive' | 'info' | 'neutral' | 'success' | 'warning';

export const getStatusTone = (status: EDocumentsStatus): TStatusTone => {
  switch (status) {
    case EDocumentsStatus.SIGNED:
      return 'success';
    case EDocumentsStatus.PENDING:
      return 'warning';
    case EDocumentsStatus.PENDING_APPROVAL:
      return 'info';
    case EDocumentsStatus.REJECTED:
    case EDocumentsStatus.CANCELED:
      return 'danger';
    case EDocumentsStatus.EXPIRED:
      return 'neutral';
    case EDocumentsStatus.DRAFT:
      return 'info';
    case EDocumentsStatus.ARCHIVED:
      return 'neutral';
    default:
      return 'neutral';
  }
};

export const getStatusBadgeVariant = (status: EDocumentsStatus): TStatusBadgeVariant => {
  switch (getStatusTone(status)) {
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    case 'danger':
      return 'destructive';
    case 'info':
      return 'info';
    default:
      return 'neutral';
  }
};

export const getStatusIconClass = (status: EDocumentsStatus) => {
  switch (getStatusTone(status)) {
    case 'success':
      return 'text-success-foreground';
    case 'warning':
      return 'text-warning-foreground';
    case 'danger':
      return 'text-destructive';
    case 'info':
      return 'text-info-foreground';
    default:
      return 'text-muted-foreground';
  }
};

export const getStatusClass = (status: EDocumentsStatus) => {
  return cn('status-pill', `status-${getStatusTone(status)}`);
};
